<div class="row mb-3">
    <div class="container-fluid">
        <div class="card card-cascade narrower">
            <mdb-card>
                <mdb-body>
                    <div class="row">
                        <div class="col-xl-3 col-md-12 col-lg-12 mr-0">
                            <div class="view view-cascade gradient-card-header blue-gradient py-2">
                                <h2 class="h3-responsive card-title font-weight-bold mb-0">Rate Tools</h2>
                            </div>
                        </div>
                        <div class="col-xl-12 col-md-12 col-lg-12 mr-0">
                            <div class="card-body card-body-cascade">
                                <div class="row">
                                    <div class="col-md-2" class="report-item py-1 px-1">
                                        <button (click)="buttonClicked('santaCruz/rates/discount-calculator')" type="button"
                                            class="btn btn-outline-primary  btn-sm waves-effect btn-block">Discount Calculator</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mdb-body>
            </mdb-card>
        </div>
    </div>
</div>